<template>
  <div>
    <!-- Header -->
    <header class="app-header">
      <nav class="navbar navbar-expand-lg">
        <div class="container">
          <a class="navbar-brand" href="#" @click="navigateToMainMenu">Proseco</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ms-auto">
              <!-- Login/Logout Button -->
              <li class="nav-item">
                <button class="btn btn-light nav-link" @click="toggleLogin">
                  {{ auth.isAuthenticated ? 'Logout' : 'Login' }}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>

    <!-- Main Content -->
    <main class="app-main">
      <router-view></router-view>
    </main>

    <!-- Footer -->
    <footer class="app-footer">
      <div class="container text-center">
        <p>&copy; 2024 Proseco - Alle Rechte vorbehalten</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { authState as auth } from './auth';

export default {
  name: 'App',
  computed: {
    auth() { return auth; }
  },
  mounted() {
    auth.checkAuthStatus();
  },
  methods: {
    toggleLogin() {
      if (auth.isAuthenticated) {
        auth.logout();
        this.$router.push({ name: 'Login' });
      } else {
        this.$router.push({ name: 'Login' });
      }
    },
    navigateToMainMenu() {
      if (auth.isAuthenticated) {
        this.$router.push({ name: 'MainMenu' });
      } else {
        this.$router.push({ name: 'Login' });
      }
    }
  }
};
</script>



<style>
/* Farben */
:root {
  --primary-color: #ff6f61;
  /* Warmes Korallenrot */
  --secondary-color: #ffc107;
  /* Helles Gelb */
  --background-color: #f5f5f5;
  /* Leichtes Grau */
  --text-color: #333;
  /* Dunkles Grau */
}

/* Header Styles */
.app-header {
  background-color: var(--primary-color);
  padding: 1rem 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.navbar-brand {
  color: white;
  font-size: 1.8rem;
  font-weight: bold;
}

.navbar-nav .nav-link {
  color: white;
  font-size: 1.2rem;
  margin-right: 1rem;
}

.navbar-nav .nav-link:hover {
  color: var(--secondary-color);
}

/* Main Content */
.app-main {
  background-color: var(--background-color);
  min-height: calc(100vh - 160px);
  padding: 2rem 0;
  color: var(--text-color);
}

/* Footer Styles */
.app-footer {
  background-color: var(--primary-color);
  color: white;
  padding: 1rem 0;
}

.app-footer p {
  margin: 0;
  font-size: 1rem;
}
</style>
